import * as React from "react";
function SvgFunnelCog(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M20 31h-8V15.36L.87 2h30.07l-6.13 8.58-1.62-1.16L27.06 4H5.13L14 14.64V29h6zm11.93-12.54a.61.61 0 01-.28.84s-.65.54-1.59 1.27a6.69 6.69 0 01-.12 2.19c.85.84 1.43 1.45 1.43 1.45a.62.62 0 01.19.87l-1.38 2.11a.63.63 0 01-.87.17s-.79-.29-1.9-.73a6.25 6.25 0 01-.93.57 6.85 6.85 0 01-1 .42c-.3 1.15-.53 2-.53 2a.64.64 0 01-.66.6L21.75 30a.64.64 0 01-.59-.67s-.14-.84-.31-2A6.71 6.71 0 0119 26.16c-1.14.32-2 .52-2 .52a.63.63 0 01-.85-.28l-1.13-2.25a.61.61 0 01.28-.84s.7-.54 1.64-1.31a6.43 6.43 0 01.12-2.19c-.85-.83-1.44-1.44-1.44-1.44a.64.64 0 01-.18-.88l1.38-2.1a.63.63 0 01.87-.18s.79.29 1.9.73a7.22 7.22 0 01.93-.57 6.85 6.85 0 011-.42c.3-1.15.53-2 .53-2a.63.63 0 01.66-.59l2.52.14a.63.63 0 01.59.66s.14.84.31 2A7 7 0 0128 16.45l2-.52a.63.63 0 01.85.28zm-9.56.6a2.51 2.51 0 103.38 1.11 2.53 2.53 0 00-3.38-1.11z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFunnelCog);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
